export default {
  CONTEXT_DEFAULT_VALUE: {
    toastConfiguration: {},
    setToastConfiguration: (): null => null,
  },
};
